// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiDbAuraInstanceIdResponse
 */
export interface ApiDbAuraInstanceIdResponse {
  /**
   *
   * @type {string}
   * @memberof ApiDbAuraInstanceIdResponse
   */
  auraInstanceId?: string;
}

/**
 * Check if a given object implements the ApiDbAuraInstanceIdResponse interface.
 */
export function instanceOfApiDbAuraInstanceIdResponse(
  value: object,
): value is ApiDbAuraInstanceIdResponse {
  return true;
}

export function ApiDbAuraInstanceIdResponseFromJSON(
  json: any,
): ApiDbAuraInstanceIdResponse {
  return ApiDbAuraInstanceIdResponseFromJSONTyped(json, false);
}

export function ApiDbAuraInstanceIdResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiDbAuraInstanceIdResponse {
  if (json == null) {
    return json;
  }
  return {
    auraInstanceId:
      json['AuraInstanceId'] == null ? undefined : json['AuraInstanceId'],
  };
}

export function ApiDbAuraInstanceIdResponseToJSON(
  json: any,
): ApiDbAuraInstanceIdResponse {
  return ApiDbAuraInstanceIdResponseToJSONTyped(json, false);
}

export function ApiDbAuraInstanceIdResponseToJSONTyped(
  value?: ApiDbAuraInstanceIdResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    AuraInstanceId: value['auraInstanceId'],
  };
}
